// Pied de page des pages publiques : marque + accroche, deux colonnes de
// liens, la ligne légale. Habillage : styles/landing.css (.lp-foot).
import { Link } from 'react-router-dom'
import { UBrand } from './Logo'
import { COMPANY } from '../../lib/legal'
import { useT } from '../../lib/i18n'

export default function Footer () {
  const t = useT()
  const f = t.footer

  return (
    <footer className="lp-foot">
      <div className="lp-wrap lp-foot__in">
        <div className="lp-foot__brand">
          <Link to="/" aria-label={t.nav.home}><UBrand /></Link>
          <p>{f.tagline}</p>
          <a href={`mailto:${COMPANY.email}`} className="lp-foot__mail">{COMPANY.email}</a>
        </div>

        <nav className="lp-foot__col" aria-label={f.product}>
          <span className="lp-foot__h">{f.product}</span>
          <a href="/#how">{t.how.kicker}</a>
          <a href="/#pricing">{f.pricing}</a>
          <a href="/#faq">{f.faq}</a>
          <Link to="/guides">{f.guides}</Link>
          <Link to="/login">{f.login}</Link>
        </nav>

        <nav className="lp-foot__col" aria-label={f.company}>
          <span className="lp-foot__h">{f.company}</span>
          <Link to="/contact">{f.contact}</Link>
          <Link to="/remboursement">{f.refund}</Link>
          <Link to="/cgv">{f.terms}</Link>
          <Link to="/confidentialite">{f.privacy}</Link>
          <Link to="/mentions-legales">{f.legal}</Link>
        </nav>
      </div>

      <div className="lp-wrap lp-foot__note">
        <span>{f.note(new Date().getFullYear())}</span>
      </div>
    </footer>
  )
}
